import { render, staticRenderFns } from "./UserProfiles.vue?vue&type=template&id=622508e1&"
import script from "./UserProfiles.vue?vue&type=script&lang=js&"
export * from "./UserProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports